"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const mark_common_1 = require("@gojipress/mark-common");
const strongPlugin = {
    name: "Strong Syntax Highlighter",
    pluginType: "renderer",
    types: [mark_common_1.GMType.Strong],
    render: node => {
        const elements = [];
        if (node.original && typeof node.original === "object" && node.original.opening) {
            const span = document.createElement("span");
            span.classList.add('gmSHStrongOpening');
            const text = document.createTextNode(node.original.opening);
            span.appendChild(text);
            elements.push({
                element: span,
            });
        }
        const contentSpan = document.createElement("span");
        contentSpan.classList.add('gmSHStrongContent');
        elements.push({
            element: contentSpan,
            childrenContainer: true,
        });
        if (node.original && typeof node.original === "object" && node.original.closing) {
            const span = document.createElement("span");
            span.classList.add('gmSHStrongClosing');
            const text = document.createTextNode(node.original.closing);
            span.appendChild(text);
            elements.push({
                element: span,
            });
        }
        return [elements, undefined];
    }
};
exports.default = strongPlugin;
